import { render, staticRenderFns } from "./MyWeChatMPUserManage.vue?vue&type=template&id=55c4760d&scoped=true"
import script from "./MyWeChatMPUserManage.vue?vue&type=script&lang=js"
export * from "./MyWeChatMPUserManage.vue?vue&type=script&lang=js"
import style0 from "./MyWeChatMPUserManage.vue?vue&type=style&index=0&id=55c4760d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4760d",
  null
  
)

export default component.exports